import { Button } from "@mui/material";
import { typeZeroWaste } from "../../../constants/constant";

interface ZeroWasteItemProps {
  item: any;
  onOpen: (id: string, price:number) => void;
  onDelete: (id: string) => void;
}

const ZeroWasteItem = (props: ZeroWasteItemProps) => {
  const { item, onOpen, onDelete } = props;

  const handleUpdate = (id:string, price:number) => {
    onOpen(id,price);
  }
  
  const name = typeZeroWaste(item.partnerPackageTypesConfigId) || item.packageTypeName;
  
  return (
    <tr>
      <td>{name}</td>
      <td>{item.price.toLocaleString("vi")} VND</td>
      <td style={{ display: 'flex', gap: '8px' }}>
        <Button onClick={() => handleUpdate(item.id, item.price)} variant="contained" size="small">
          Cập nhật
        </Button>
        <Button onClick={() => onDelete(item.id)} variant="contained" color="error" size="small">
          Xóa
        </Button>
      </td>
    </tr>
  );
};

export default ZeroWasteItem;